import isEmpty from 'lodash/isEmpty';
import { ACADEMY_ONBOARDING_URL, MENU_LINKS } from '../../../config/routes';
import { User } from '../../../models/User';
import { getHomeScreenUrl } from '../../../helpers/homeScreenUrlHelper';
import { BILLING_BASE, SENDBOARD_LOCATION_HASH } from '../../constants/productsUrlHashes';

export const isPaymentUrl = (url: string): boolean => {
    const paymentBase = '#/billing';
    return url.includes(paymentBase);
};
export const shouldShowActivationEmailModal = (currentUrlHash: string, user?: User): boolean => {
    const notActiveUser = !isEmpty(user) && !user?.notifications?.isActive;
    const activeUser = !notActiveUser;
    const canRedirectToHomeUrl = activeUser && currentUrlHash === '';
    const needsWelcome = !isEmpty(user) && user?.notifications?.needsWelcome;
    const sameUrl = currentUrlHash.includes(ACADEMY_ONBOARDING_URL);
    const canRedirectOnboardingModal = needsWelcome && !sameUrl;

    if (isPaymentUrl(currentUrlHash)) {
        return false;
    }

    if (canRedirectOnboardingModal) {
        window.location.hash = ACADEMY_ONBOARDING_URL;
    }

    if (canRedirectToHomeUrl) {
        window.location.hash = getHomeScreenUrl(user?.homeScreen);
    }
    return notActiveUser;
};

export const isToggleAllComponents = (currentUrlHash: string): boolean => {
    if (
        currentUrlHash.includes(MENU_LINKS.PAYMENT.BASE) ||
        currentUrlHash.includes(BILLING_BASE) ||
        currentUrlHash.includes(SENDBOARD_LOCATION_HASH)
    ) {
        return false;
    }
    return true;
};

export const shouldShowTemplatesMicro = (currentUrlHash: string): boolean => {
    return currentUrlHash.indexOf(MENU_LINKS.TEMPLATE_LIST.BASE) > -1;
};

export const isCollapsibleMenu = (currentUrlHash: string): boolean => {
    return currentUrlHash.includes(SENDBOARD_LOCATION_HASH);
};
